import React from 'react'

import WizIcon from '@component/images/WizIcon'
import WizCustomViewMenu from '@component/menu/WizMenu/WizCustomViewMenu'
import HorizontalDivider from '@component/divider/HorizontalDivider'

import LanguageSettingOperation from '@component/header/GlobalNavigation/NavigationOperations/SettingOperation/LanguageSettingOperation'
import CurrencySettingOperation from '@component/header/GlobalNavigation/NavigationOperations/SettingOperation/CurrencySettingOperation'
import AppearanceSettingOperation from '@component/header/GlobalNavigation/NavigationOperations/SettingOperation/AppearanceSettingOperation'
import SettingIcon from '@svg/gnb/ic_setting.svg'

interface IProps {
    className?: string
}

const marginTop = 15
const NavigationSettingOperationMenu = ({className}: IProps) => {
    return (
        <WizCustomViewMenu
            enableHover
            placement={'bottom-end'}
            baseChildren={<BaseChildren className={className} />}
            floatingStyle={{marginTop}}>
            <div
                className={
                    'w-full p-[5px] min-w-[260px] border rounded-[5px] shadow-normal bg-white dark:bg-bg_dark_popup dark:shadow-dark_normal border-[#F2F4F6] dark:border-[#37393E]'
                }>
                <LanguageSettingOperation />
                <HorizontalDivider className={'bg-gray08 dark:bg-dark_gray08 my-[5px]'} />
                <CurrencySettingOperation />
                <HorizontalDivider className={'bg-gray08 dark:bg-dark_gray08 my-[5px]'} />
                <AppearanceSettingOperation />
            </div>
        </WizCustomViewMenu>
    )
}

export default NavigationSettingOperationMenu

const BaseChildren = ({className}: {className?: string}) => {
    return (
        <WizIcon className={`p-[6px] hover:bg-transparent01 dark:hover:bg-dark_transparent01 ${className}`}>
            <SettingIcon className={className} />
        </WizIcon>
    )
}
